import { render, staticRenderFns } from "./CustomerDetailsNotesHistory.vue?vue&type=template&id=7ff3a380"
import script from "./CustomerDetailsNotesHistory.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsNotesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports